module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"info":{"1":"Les prix affichés comprennent les taxes aéroport et frais de dossier.","2":"Les disponibilités sont affichées en temps réel et peuvent évoluer d\u0027une minute à l\u0027autre."}},"en":{"info":{"1":"The prices shown include airport taxes and booking fees.","2":"Availabilities are displayed in real time and can change from one minute to the next."}}}')
  delete Component.options._Ctor
}
